//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    addToCategoryResultCode()
    rebuildTopCategoryResult()

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultCategoryItems = []
  var arrayResultTextItems = []
  var arrayResultEmptyTextItems = []
  var arrayResultBtnItems = []
  var arrayResultPhoneItems = []
  var arrayResultMobileItems = []
  var arrayResultEmailItems = []
  var arrayResultSideCategory = []
  var mainItem = false
  var anotherItemText = true
  var anotherItemSubtext = true
  var anotherItemBtn = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    item.find('.js-json-input').each(function () {
      input = $(this)
      var dataJson = input.attr('data-json')
      var dataVar = input.attr('data-var')
      if (input.val().length > 0) {
        var inputValue = input.val()
        if (dataVar === 'bannerRatingAddonTitleLang') {
          arrayResultTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'bannerRatingAddonTextEmptyLang') {
          arrayResultEmptyTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'bannerRatingAddonTextBtnLang') {
          arrayResultBtnItems.push(`${dataJson}:"${inputValue}"`)
        }
      }
    })

    if (anotherItemText) {
      if (arrayResultTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">bannerRatingAddonTitleLang</span> = <span class="js-result-value txt-green">{${arrayResultTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemText = false
      }
    }

    if (anotherItemSubtext) {
      if (arrayResultEmptyTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">bannerRatingAddonTextEmptyLang</span> = <span class="js-result-value txt-green">{${arrayResultEmptyTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemSubtext = false
      }
    }

    if (anotherItemBtn) {
      if (arrayResultBtnItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">bannerRatingAddonTextBtnLang</span> = <span class="js-result-value txt-green">{${arrayResultBtnItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemBtn = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputDivider = inputParent.data('divider')
      var inputType = inputParent.data('type')

      if (inputDivider == true) {
        inputValue = '/' + inputValue
      }

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (input.hasClass('js-json-input')) {
      } else {
        if (blockItemCSS) {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategoryCSS.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
        } else {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategory.push(templateBoxItem)
          arrayResultSideCategory.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
        }
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      if (element.attr('data-type') === 'option') {
        checkboxValue = `"${element.find('select').val()}"`
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var bannerRatingSidebar
var bannerRatingTemplate
var bannerRatingRadius = ''
var bannerRatingBG = ''
var bannerRatingBGOverlay = ''
var bannerRatingBGOverlaySet = ''
var bannerRatingBGSide = ''
var bannerRatingBorder = ''
var bannerRatingRow = ''
var bannerRatingIcon = ''

var bannerRatingAddonTitle = ''
var bannerRatingAddonText = ''
var bannerRatingAddonLink = ''

var bannerRatingTitle = ''
var bannerRatingText = ''
var bannerRatingLink = ''
var bannerRatingBtn = ''
var bannerRatingTextBtn = ''
var bannerRatingList = ''

var bannerRatingListPhone = ''
var bannerRatingListMobile = ''
var bannerRatingListEmail = ''

function rebuildTopCategoryResult() {
  buttonsBlock = $('.result-block')

  bannerRatingAddon = $('#banner_rating_active').is(':checked')
  bannerRatingAddonRadius = $('#banner_rating_radius').is(':checked')

  bannerRatingAddonTitle = $('#banner_rating_title').val()
  bannerRatingAddonText = $('#banner_rating_text').val()
  bannerRatingAddonTextBtn = $('#banner_rating_text_btn').val()
  bannerRatingEmail = $('#banner_rating_email').val()
  bannerRatingPhone = $('#banner_rating_phone').val()
  bannerRatingMobile = $('#banner_rating_mobile').val()

  bannerRatingLink = $('#banner_rating_link').is(':checked')
  bannerRatingLinkHref = $('#banner_rating_link_url').val()
  bannerRatingBtnHrefExternal = $('#banner_rating_link_url_external').is(
    ':checked',
  )

  bannerRatingAddonBG = $('#banner_rating_bg').is(':checked')
  bannerRatingAddonBorder = $('#banner_rating_border').is(':checked')

  bannerRatingAddonCenter = $('#banner_rating_center').is(':checked')
  bannerRatingAddonRow = $('#banner_rating_row').is(':checked')
  bannerRatingAddonBtn = $('#banner_rating_btn').is(':checked')

  // CSS
  let root = document.documentElement

  root.style.setProperty(
    '--banner-rating-border-radius',
    $('#banner_rating_border_radius').val(),
  )

  root.style.setProperty('--banner-rating-BG', $('#banner_rating_bgs').val())

  root.style.setProperty(
    '--banner-rating-BG-hover',
    $('#banner_rating_bg-hover').val(),
  )

  root.style.setProperty(
    '--banner-rating-title-color',
    $('#banner_rating_title_color').val(),
  )

  root.style.setProperty(
    '--banner-rating-text-color',
    $('#banner_rating_text_color').val(),
  )

  root.style.setProperty(
    '--banner-rating-number-color',
    $('#banner_rating_number_color').val(),
  )

  root.style.setProperty(
    '--banner-rating-link-color',
    $('#banner_rating_link_color').val(),
  )

  root.style.setProperty(
    '--banner-rating-icon-color',
    $('#banner_rating_icon_color').val(),
  )

  root.style.setProperty(
    '--banner-rating-btn-bg',
    $('#banner_rating_btn_bg').val(),
  )

  root.style.setProperty(
    '--banner-rating-btn-bg-hover',
    $('#banner_rating_btn_bg_hover').val(),
  )

  root.style.setProperty(
    '--banner-rating-btn-color',
    $('#banner_rating_btn_color').val(),
  )

  root.style.setProperty(
    '--banner-rating-border-color',
    $('#banner_rating_border_color').val(),
  )

  if (bannerRatingAddon) {
    $('body').addClass('banner-rating-addon')
    removeButton()
    setBannerRatingText()
    setBannerRatingBtn()
    setBannerRatingDesign()
    createBannerRating()
  } else {
    $('body').removeClass('banner-rating-addon')
    removeButton()
  }
}

function createBannerRating() {
  bannerRatingTemplate = `
		<div class="box box-sm banner-rating-box">
			<div class="banner-rating js-banner-rating ${bannerRatingBorder} ${bannerRatingRow} ${bannerRatingRadius} ${bannerRatingCenter} ${bannerRatingBG}">
				<div class="banner-rating__text-block">
					<div class="banner-rating__title">${bannerRatingTitle}</div>
				</div>
				<div class="banner-rating__stats-block js-banner-rating-stats-block">
					<span class="rate-average">5,0</span>
					<span class="rate-star-wrap">
						<span class="stars">
							<a class="star star-on"></a>
							<a class="star star-on"></a>
							<a class="star star-on"></a>
							<a class="star star-on"></a>
							<a class="star star-on"></a>
						</span>
						<span class="stars-label">2 hodnotenia</span>
					</span>
				</div>
				${bannerRatingBtn}
			</div>
		</div>
	`
  $('.result-block').append($(bannerRatingTemplate))
}

function setBannerRatingBtn() {
  if (bannerRatingAddonBtn) {
    if (bannerRatingBtnHrefExternal == true) {
      bannerRatingBtn = `
				<a href="${bannerRatingLink}" class="banner-rating__btn btn btn-secondary" target="_blank">${bannerRatingTextBtn}</a>
			`
    } else {
      bannerRatingBtn = `
				<a href="${bannerRatingLink}" class="banner-rating__btn btn btn-secondary">${bannerRatingTextBtn}</a>
			`
    }
  } else {
    bannerRatingBtn = ''
    bannerRatingLinkHref = ''
  }
}

// Set design for button in detail
function setBannerRatingDesign() {
  if (bannerRatingAddonRadius) {
    bannerRatingRadius = 'has-border-radius'
  } else {
    bannerRatingRadius = ''
  }

  if (bannerRatingAddonBG) {
    bannerRatingBG = 'has-bg'
  } else {
    bannerRatingBG = ''
  }

  if (bannerRatingAddonBorder) {
    bannerRatingBorder = 'has-border'
  } else {
    bannerRatingBorder = ''
  }

  if (bannerRatingAddonCenter) {
    bannerRatingCenter = 'is-centered'
  } else {
    bannerRatingCenter = ''
  }
  if (bannerRatingAddonRow) {
    bannerRatingRow = 'is-row'
  } else {
    bannerRatingRow = ''
  }
}

// Set text for button in detail
function setBannerRatingText() {
  if (bannerRatingAddonTitle) {
    bannerRatingTitle = bannerRatingAddonTitle
  } else {
    bannerRatingTitle = ''
  }

  if (bannerRatingAddonText) {
    bannerRatingText =
      '<div class="banner-rating__text">' + bannerRatingAddonText + '</div>'
  } else {
    bannerRatingText = ''
  }

  if (bannerRatingLinkHref) {
    bannerRatingLink = bannerRatingLinkHref
  } else {
    bannerRatingLink = ''
  }

  if (bannerRatingAddonTextBtn) {
    bannerRatingTextBtn = bannerRatingAddonTextBtn
  } else {
    bannerRatingTextBtn = ''
  }
}

function removeButton() {
  $('.result-block > div').remove()
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    inputColor.val('#' + inputValue)
    // inputColor.trigger('change')
  })
})
